import React from "react";
import ContactHero from "./ContactHero";
import ContactInformation from "./ContactInformation";
import MapArea from "./MapArea";

const Contact = () => {
  return (
    <>
      <ContactHero />
      <ContactInformation />
      <MapArea />
    </>
  );
};

export default Contact;
